"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BHGCard = void 0;

var _react = _interopRequireDefault(require("react"));

require("./Card.scss");

var _Button = require("../Button/Button");

var BHGCard = function BHGCard(props) {
  var image = props.image,
      imgAlt = props.imgAlt,
      imgClass = props.imgClass,
      title = props.title,
      content = props.content,
      ctaText = props.ctaText,
      ctaClick = props.ctaClick,
      ctaClass = props.ctaClass,
      children = props.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "bhg-card"
  }, image && /*#__PURE__*/_react.default.createElement("div", {
    className: "bhg-card-image-container"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: image,
    alt: imgAlt,
    className: "bhg-card-img " + imgClass
  })), title && /*#__PURE__*/_react.default.createElement("span", {
    className: "bhg-card-title"
  }, title), content && /*#__PURE__*/_react.default.createElement("p", {
    className: "bhg-card-content"
  }, content), ctaText && ctaClick && /*#__PURE__*/_react.default.createElement(_Button.BHGButton, {
    onClick: ctaClick,
    appearance: ctaClass
  }, ctaText), children);
};

exports.BHGCard = BHGCard;
BHGCard.defaultProps = {
  image: "",
  imgAlt: "",
  imgClass: "",
  title: "",
  content: "",
  ctaText: "",
  ctaClick: null,
  ctaClass: "primary",
  children: null
};